module.exports = __webpack_public_path__ + "static/media/w_overcast.fd594007.svg";